import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-auth-types-save-confirmation-new',
  templateUrl: './auth-types-save-confirmation-new.component.html',
  styleUrls: ['./auth-types-save-confirmation-new.component.scss']
})
export class AuthTypesSaveConfirmationNewComponent  {

  copyData = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }

}
